// Purpose: Profile API calls
// Caller: profileAction
// Dependencies: utils/xhr
// Main Functions: getProfile, updateProfile
// Side Effects: HTTP GET /profile, PUT /profile/update

import { xhr } from 'utils'

export const getProfile = () => xhr.get('/profile')
export const updateProfile = (data) => xhr.put('/profile/update', data)
